var countries = require('json!../../../../../config/countries.json');
angular.module('account.tags.add', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'services.localizedMessages',
  'directives.serverError',
  'resources.Tag',
  'ui.bootstrap.dropdown',
  'services.formErrors',
  'ngFileUpload',
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('account.tags.add', {
      url: '/add',
      title: 'Account Tags / Details',
      views: {
        'main@': {
          template: require('./tag-add.tpl.html'),
          controller: 'AccountTagAddCtrl'
        }
      },
      resolve: {
        user: ["User", "$state", "$location", function(User, $state, $location) {

          return User.current(function (user) {
            if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
              return user;
            }
            return $state.go('unauthorized');
          }).$promise;
        }],
      }
    });
}])

.controller('AccountTagAddCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "Tag", "formErrors", "growl", "dateFilter", "Upload", "localizedMessages", "APP_IMG_URLS", function($scope, $route, $location, $log, utility, adminResource, Tag, formErrors, growl, dateFilter, Upload, localizedMessages, APP_IMG_URLS) {
    $scope.localizedMessages = localizedMessages;
    var slugify = require('underscore.string/slugify');
    $scope.dataLoaded = true;
    $scope.imgUrl = APP_IMG_URLS.base;

    $scope.countries = [];
    _.forIn(countries, function (value, key) {
      $scope.countries.push({
        _id: key,
        name: value
      });
    });

    $scope.data = {
      avatar_url: null,
      big_avatar_url: null
    }

    $scope.tag = {
      avatar: "",
      big_avatar: "",
      bios: [{
        bio: "",
        rol: "",
        language: ""
      }]
    }

    $scope.$watch('avatar', function (file) {
      if (!file) return;
      $scope.uploadAvatar(file);
    });
    $scope.$watch('big_avatar', function (file) {
      if (!file) return;
      $scope.uploadBigAvatar(file);
    });

    $scope.uploadAvatar = function (file) {
      $scope.avatar_uploading = true;
      $scope.tag.avatar = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.avatar_uploading = false;
        $scope.tag.avatar = resp.data.filename;
        $scope.data.avatar_url = APP_IMG_URLS.base + resp.data.filename;
      }, function (resp) {
        $scope.avatar_uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    }

    $scope.uploadBigAvatar = function (file) {
      $scope.big_avatar_uploading = true;
      $scope.tag.big_avatar = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.big_avatar_uploading = false;
        $scope.tag.big_avatar = resp.data.filename;
        $scope.data.big_avatar_url = APP_IMG_URLS.base + resp.data.filename;
      }, function (resp) {
        $scope.big_avatar_uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    }

    $scope.generateThumb = function(file, rejFile){
      if(file === null && rejFile === undefined){
        growl.info('Max image size is 10MB!',3);
      }
    }

    $scope.addNewChoice = function($event) {
      $event.preventDefault()
      var newBio = {
        bio: "",
        rol: "",
        language: ""
      }
      $scope.tag.bios.push(newBio);
    };
    $scope.closeDetailAlert = function () {
      $scope.detailAlerts = []
    }

    $scope.removeChoice = function(index,$event) {
      $event.preventDefault()
      $scope.tag.bios.splice(index, 1);
    };

    $scope.submit = function () {
      var oficialsave = 0;
      if($scope.tag.oficial){
        oficialsave = 1;
      }
      var data = angular.copy($scope.tag);
      data.sefriendly = slugify(data.name);
      data.oficial = oficialsave;
      data.place = {}
      data.place.country = data.country ? data.country.name : ""
      data.place.city = data.city
      data.start_date = dateFilter(data.start_date, 'yyyy-MM-dd')
      data.end_date = dateFilter(data.end_date, 'yyyy-MM-dd')
      var nolang = data.bios.filter(function (item) {
        return !item.language
      })
      if (nolang.length > 0) {
        $scope.detailAlerts = []
        $scope.detailAlerts.push({
          type: 'danger',
          msg: 'Missing language'
        })
      } else {
        $scope.dataLoaded = false;
        Tag.save(data, function (result) {
          $scope.dataLoaded = true;
          growl.info('Tag saved!');
          $location.path('/account/tags/edit/' + result._id);
        }, formErrors.growlErrors);
      }

    };
  }]);



// WEBPACK FOOTER //
// ./client/src/app/account/tags/tag-add.js